export default __webpack_public_path__ + "static/media/section-process-bg4.df71340a.png";